import { request } from '@/utils/request'

/** 获取用户账号信息 */
export const getAccountInfo = () => request.get('/api/account/index')

/** 保存收货地址 */
export const saveAddress = data => request.post('/api/receiveAddress/submit', data)

/** 获取订单列表 */
export const getOrderList = params => request.post('/api/order/search', params)

/** 订单详情 */
export const orderDetail = id => request.get('/api/order/detail', { id })

/** 取消订单 */
export const orderCancel = id => request.post('/api/order/cancel', { id })

/** 删除订单 */
export const orderDelete = id => request.post('/api/order/delete', { id })

/** 确认收货 */
export const orderConfirm = id => request.post('/api/order/confirmReceive', { id })

/** 获取待评价订单 */
export const waitCommentList = params => request.get('/api/order/evaluate/wait_list', params)

/** 待评价商品订单详情 */
export const waitCommentOrderGoodsList = id =>
  request.get('/api/order/evaluate/wait_order_goods_list', { id })

/** 提交评论 */
export const submitComment = data => request.post('/api/order/evaluate/submit', data)

/** 查询快递物流轨迹 */
export const getExpressTrack = id => request.get('/api/express/track', { id })
